import { ValueTypeEnum } from '@models/common.model';

// INTERFACES ########################################################

/**
 * The GroupConfig Interface
 *
 * @identifier {string} custom group item identifier
 * @collapsable {boolean} flag to make contents collapsable, default value is: true
 * @defaultState {GroupStateEnum} initial state of contents visibility, default value is: EXPANDED
 * @disabled {boolean} flag to disable group, default value is: false
 * @labelClass {string} custom class for label
 * @labelValue {string} for valueType i18n the value has to be an absolute i18n path | for value valueType the string value
 * @labelValueType {ValueTypeEnum} either i18n or value, affects the value prop
 * @labelSpareValue {string} fallback value
 * @renderHeader {boolean} *ngIf group header flag, default is: true
 * @showHeaderSeparator {boolean} flag to render header separator in DOM, default is: false
 * @showFooterSeparator {boolean} flag to render footer separator in DOM, default is: false
 * @showLabel {boolean} flag to render label in DOM, default is: true
 * @showToggleIcon {boolean} flag to render toggleIcon in DOM, default is: true
 * @toggleIconClass {string} custom class for toggleIcon
 */
export interface IGroupConfig {
	identifier?: string;
	collapsable?: boolean;
	defaultState?: GroupStateEnum;
	disabled?: boolean;
	labelClass?: string;
	labelValue: string;
	labelValueType: ValueTypeEnum;
	labelSpareValue?: string;
	renderHeader?: boolean;
	showHeaderSeparator?: boolean;
	showFooterSeparator?: boolean;
	showLabel?: boolean;
	showToggleIcon?: boolean;
	toggleIconClass?: string;
}


// ENUMS #############################################################
export enum GroupStateEnum {
	COLLAPSED = 'collapsed',
	EXPANDED = 'expanded'
}
